import { SchoolOptionAPIResponse } from 'types';

/**
 * @summary utility function to extract school logo
 * @private
 */
export function getSchoolLogoUrlMap(
  images: SchoolOptionAPIResponse['schoolImages']
): {
  mobile: string;
  desktop: string;
} {
  const defaultImgUrl = '/theme-assets/click-portal/tablet.png';
  return {
    mobile:
      images?.Mobile?.imageUrl || images?.Desktop?.imageUrl || defaultImgUrl,
    desktop: images?.Desktop?.imageUrl || defaultImgUrl,
  };
}
